<template>
  <div>
    <b-container fluid>
      <b-row>
        <b-col cols="12" class="p-0">
          <TopBarMember class="mb-0 mb-sm-3" />
        </b-col>
      </b-row>
    </b-container>
    <List v-if="page === undefined || page == 'list'" />
    <Add v-if="page == 'add'" />
    <Detail v-if="page == 'detail'" :id="id" />
    <FooterIndex class="mt-3" />
  </div>
</template>

<script>
import { Component, Vue, Prop } from "vue-property-decorator";

// Include Component
import List from "@/components/member/numberSet/List.vue";
import Add from "@/components/member/numberSet/Add.vue";
import Detail from "@/components/member/numberSet/Detail.vue";
import TopBarMember from "@/components/TopBarMember.vue";
import FooterIndex from "@/components/Footer.vue";

export default {
  name: 'NumberSet',
  components: {
    TopBarMember,
    List,
    Add,
    Detail,
    FooterIndex
  },
  props: ['page', 'id']
}
</script>